import {Injectable} from '@angular/core';
import {FavoriteModuleDto} from '../../../Models/Module/favorite-module.interface';
import {UserPreferencesModelService} from '../Session/user-preferences-model.service';

@Injectable({
  providedIn: 'root'
})
export class FavoritesModulesService extends UserPreferencesModelService<FavoriteModuleDto> {

  tableName = 'yu_v3_favorites_modules';

  /**
   * Conserva solo el identificador del acceso
   *
   */
  protected mapLegacyItem(item: any): FavoriteModuleDto {
    return {id: item.id};
  }

}
